var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card mb-4",
      staticStyle: {
        "border-radius": "12px",
        "box-shadow": "0 4px 6px rgba(0,0,0,0.1)",
      },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row g-2" }, [
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "kpi-card kpi-card-success p-3 d-flex align-items-center justify-content-between",
              },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("i", { staticClass: "fal fa-user-check fa-2x mr-3" }),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", { staticClass: "mb-0 kpi-label" }, [
                      _vm._v("AGENTES DISPONIBLES"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0 kpi-value" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.availableCount) +
                          "\n                            "
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "kpi-card kpi-card-danger p-3 d-flex align-items-center justify-content-between",
              },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("i", { staticClass: "fal fa-user-slash fa-2x mr-3" }),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", { staticClass: "mb-0 kpi-label" }, [
                      _vm._v("AGENTES DESCONECTADOS"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0 kpi-value" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.disconnectedCount) +
                          "\n                            "
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "card-header d-flex align-items-center",
        staticStyle: {
          "background-color": "#F8FAFC",
          "border-radius": "12px 12px 0 0",
        },
      },
      [
        _c("i", { staticClass: "fal fa-user-headset text-primary mr-2" }),
        _vm._v(" "),
        _c("h5", { staticClass: "mb-0 font-weight-bold" }, [
          _vm._v("Estado de conexión de agentes"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }